var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlarmsDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 56",
    style: {
      enableBackground: "new 0 0 50 56"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#B4CCDD;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.6,18.8l-1.5-1.5c-2.6,2-4.4,5.1-4.6,8.6h2.2C15.9,22.8,17.3,20.3,19.6,18.8L19.6,18.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.3,25.8h2.2c-0.2-3.5-1.9-6.6-4.5-8.6l-1.5,1.5C32.7,20.3,34.1,22.8,34.3,25.8L34.3,25.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.2,26.4c0-3.4-2.3-6.2-5.5-6.9v-0.8c0-0.9-0.8-1.6-1.7-1.6c-0.9,0-1.6,0.8-1.6,1.6v0.8 c-3.2,0.8-5.5,3.5-5.5,6.9v6l-2.2,2.2v1.1h18.7v-1.1l-2.2-2.2V26.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25,39h0.4c0.8-0.1,1.3-0.7,1.5-1.3c0.1-0.2,0.2-0.5,0.2-0.9h-4.4C22.8,38,23.8,39,25,39L25,39z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmsDefault);
export default __webpack_public_path__ + "static/media/alarms-default.28afbf3f39f95d70cb1a7a824b9fa8b0.svg";
export { ForwardRef as ReactComponent };